import React from 'react';
import styles from './FileTooltip.module.css';

interface FileTooltipProps {
  fileName: string;
  uploadDate?: string;
  fileSize?: number;
  children: React.ReactNode;
}

export const FileTooltip: React.FC<FileTooltipProps> = ({ 
  fileName, 
  uploadDate, 
  fileSize, 
  children 
}) => {
  const formatFileSize = (bytes?: number) => {
    if (!bytes) return 'N/A';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  };

  return (
    <div className={styles.tooltipContainer}>
      {children}
      <div className={styles.tooltipContent}>
        <div><strong>File:</strong> {fileName}</div>
        {uploadDate && <div><strong>Uploaded:</strong> {new Date(uploadDate).toLocaleString()}</div>}
        {fileSize && <div><strong>Size:</strong> {formatFileSize(fileSize)}</div>}
      </div>
    </div>
  );
};
